
import { useState } from "react";
import { Box, Tab, Tabs, } from "@mui/material";
import { a11yProps, EstadoSolicitudDeudaENUM, sizeTab, useCheckPermissionsArray, } from "@/shared";
import { CustomTabPanel, SingleTableBoxScene } from "@/shared/components/ui";
import { PermissionsEnum } from "@/auth/interfaces";
import TableSolicitudDeuda from "../../component/table_solicitud_deuda/TableSolicitudDeuda";

export default function SolicicitudDeudaPage() {

  useCheckPermissionsArray([
    PermissionsEnum.api_view_solicitudpasardeuda,
    PermissionsEnum.api_change_solicitudpasardeuda
  ]);

  const [valueTab, setValueTab] = useState(0);
  return (
    <SingleTableBoxScene title={"Solicitud Pasar Deuda"}
      py={2}
    >
      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs preventa"
        >
          <Tab label={'Pendiente'} {...a11yProps(0)} />
          <Tab label={'Aprobada'} {...a11yProps(1)} />
          <Tab label={'Rechazada'} {...a11yProps(2)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTab} index={0}>
        <TableSolicitudDeuda />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={1}>
        <TableSolicitudDeuda
          estado_solicitud={EstadoSolicitudDeudaENUM.APROBADO}
          enableActions={false}
        />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={2}>
        <TableSolicitudDeuda
          estado_solicitud={EstadoSolicitudDeudaENUM.RECHAZADO}
          enableActions={false}
        />
      </CustomTabPanel>
    </SingleTableBoxScene >
  );
}